import { __assign } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gs } from '../utils';
export var Thumbnail = function (props) {
    return props.color ? (jsx(ThumbnailWithBackground, __assign({}, props))) : (jsx(ThumbnailDefault, __assign({}, props)));
};
var sharedStyles = {
    // The dimensions of the image are set in this manner
    // in order for `flex` to respect this value.
    minWidth: gs(20),
    maxWidth: gs(20),
    height: gs(15),
};
export var ThumbnailDefault = function (_a) {
    var src = _a.src, testId = _a.testId;
    return (jsx("div", { css: __assign(__assign({}, sharedStyles), { backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: '50% 50%', backgroundImage: "url(" + src + ")" }), "data-testid": testId }));
};
export var ThumbnailWithBackground = function (_a) {
    var src = _a.src, color = _a.color, testId = _a.testId;
    return (jsx("div", { css: __assign(__assign({}, sharedStyles), { backgroundColor: color, display: 'flex', alignItems: 'center', justifyContent: 'center' }), "data-testid": testId },
        jsx("img", { src: src, css: { height: '90px', width: '90px' } })));
};
//# sourceMappingURL=Thumbnail.js.map